import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "../Postermain/Postermain.css";

gsap.registerPlugin(ScrollTrigger);

const Postermain = () => {
  const rightContentRef = useRef(null);

  useEffect(() => {
    gsap.fromTo(
      rightContentRef.current,
      { x: 200, opacity: 0 },
      {
        x: 0,
        opacity: 1,
        duration: 4,
        ease: "power2.out",
        scrollTrigger: {
          trigger: rightContentRef.current,
          start: "top 90%",
          end: "top 40%",
          scrub: 2,
        },
      }
    );
  }, []);

  const blogs = [
    { id: 1, image: "/b1.jpg", location: "Dubai", timing: "5 Days - 4 Nights", price: "£500", link: "/" },
    { id: 2, image: "/b2.jpg", location: "USA", timing: "6 Days - 5 Nights", price: "£650", link: "/destination/usa" },
    { id: 3, image: "/b3.jpg", location: "Australia", timing: "7 Days - 6 Nights", price: "£800", link: "/destination/australia" },
  ];

  const calladmin = () => {
    window.location.href = "tel:02039449931";
  };

  return (
    <div className="postermain">
      <div className="left-content">
        <p className="best-dh">Best Destinations around the world</p>
        <h1>Escape the ordinary... Embrace the extraordinary</h1>
        <section className="blog-sectionn">
          <div className="blog-container">
            {blogs.map((blog) => (
              <div key={blog.id} className="blog-cardd">
                <div className="blog-imagee">
                  <img src={blog.image} alt={blog.location} />
                </div>
                <h3 className="blog-location">{blog.location}</h3>
                <p className="blog-timing">{blog.timing}</p>
                <p className="blog-pricing">Price: {blog.price}</p>
                <div className="bncn">
                  <Link to={blog.link}>
                    <button className="blog-button">Book Now</button>
                  </Link>
                  <button className="blog-button" onClick={calladmin}>Call Now</button>
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
      <div className="right-content" ref={rightContentRef}>
        <img src="/hero-img.png" alt="Fashion" />
      </div>
    </div>
  );
};

export default Postermain;
